export default "/icon-speaker.svg";